import { Menu, MenuHeader, MenuItem } from "@szhsin/react-menu";
import * as React from "react";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Context } from "../../context/context";
import { getWebTheme, webThemes } from "../../theme/themes";
import { SettingsIcon } from "../Icons";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css"

// Settings in the header: the three themes, each with its swatch, the chosen one checked.
const SettingsMenu: FunctionComponent<{ context: Context }> = ({ context }) => {
    const { t } = useTranslation();
    const current = getWebTheme(context.themeManager.theme);
    const menuButton = ({ open }: { open: boolean }) => (
        <button className={"ibtn" + (open ? " on" : "")} aria-label={t("Settings")} title={t("Settings")}>
            <SettingsIcon />
        </button>
    );
    return (
        <Menu menuButton={menuButton} menuClassName="settings" transition align="end" offsetY={8}>
            <MenuHeader>{t("Theme")}</MenuHeader>
            {webThemes.map((theme) => (
                <MenuItem
                    key={theme.id}
                    type="checkbox"
                    checked={theme === current}
                    onClick={() => (context.themeManager.theme = theme)}>
                    <span className="swd" style={{ background: `linear-gradient(135deg, ${theme.swatch.board} 0 50%, ${theme.swatch.accent} 50% 100%)` }} />
                    {t(theme.nameKey)}
                </MenuItem>
            ))}
        </Menu>
    );
};

export default SettingsMenu;
